import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=9bc1b88c&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"
import style0 from "./Participants.vue?vue&type=style&index=0&id=9bc1b88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc1b88c",
  null
  
)

export default component.exports